(function($) {
    "use strict";
    $(".mobile-toggle").click(function(){
        $(".nav-menus").toggleClass("open");
    });
    $(".mobile-toggle-left").click(function(){
        $(".left-header").toggleClass("open");
    });
    $(".mobile-search").click(function(){
       $(".form-control-plaintext").toggleClass("open");
   });
    $(".bookmark-search").click(function(){
        $(".form-control-search").toggleClass("open");
    })
    $(".filter-toggle").click(function(){
        $(".product-sidebar").toggleClass("open");
    });
    $(".toggle-data").click(function(){
        $(".product-wrapper").toggleClass("sidebaron");
    });
    $(".form-control-search").keyup(function(e){
        if(e.target.value) {
            $(".page-wrapper.horizontal-wrapper").addClass("offcanvas-bookmark");
        } else {
            $(".page-wrapper.horizontal-wrapper").removeClass("offcanvas-bookmark");
        }
    });
})(jQuery);

$('.loader-wrapper').fadeOut('slow', function() {
    $(this).remove();
});

$(window).on('scroll', function() {
    if ($(this).scrollTop() > 600) {
        $('.tap-top').fadeIn();
    } else {
        $('.tap-top').fadeOut();
    }
});


$('.media-size-email svg').on('click', function (e) {
    $(this).toggleClass("like");
});



$('.tap-top').click( function() {
    $("html, body").animate({
        scrollTop: 0
    }, 600);
    return false;
});

function toggleFullScreen() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        }
    }
}
(function($, window, document, undefined) {
    "use strict";
    var $ripple = $(".js-ripple");
    $ripple.on("click.ui.ripple", function(e) {
        var $this = $(this);
        var $offset = $this.parent().offset();
        var $circle = $this.find(".c-ripple__circle");
        var x = e.pageX - $offset.left;
        var y = e.pageY - $offset.top;
        $circle.css({
            top: y + "px",
            left: x + "px"
        });
        $this.addClass("is-active");
    });
    $ripple.on(
        "animationend webkitAnimationEnd oanimationend MSAnimationEnd",
        function(e) {
            $(this).removeClass("is-active");
        });
})(jQuery, window, document);


// active link
$(".chat-menu-icons .toogle-bar").click(function(){
    $(".chat-menu").toggleClass("show");
});


// Language
var tnum = 'en';
$(document).ready(function () {
    if (localStorage.getItem("primary") != null) {
        var primary_val = localStorage.getItem("primary");
        $("#ColorPicker1").val(primary_val);
        var secondary_val = localStorage.getItem("secondary");
        $("#ColorPicker2").val(secondary_val);
    }
    $(document).click(function (e) {
        $('.translate_wrapper, .more_lang').removeClass('active');
    });
    $('.translate_wrapper .current_lang').click(function (e) {
        e.stopPropagation();
        $(this).parent().toggleClass('active');

        setTimeout(function () {
            $('.more_lang').toggleClass('active');
        }, 5);
    });

    /*TRANSLATE*/
    translate(tnum);

    $('.more_lang .lang').click(function () {
        $(this).addClass('selected').siblings().removeClass('selected');
        $('.more_lang').removeClass('active');

        var i = $(this).find('i').attr('class');
        var lang = $(this).attr('data-value');
        var tnum = lang;
        translate(tnum);

        $('.current_lang .lang-txt').text(lang);
        $('.current_lang i').attr('class', i);


    });
});

function translate(tnum) {
    $('.lan-1').text(trans[0][tnum]);
    $('.lan-2').text(trans[1][tnum]);
    $('.lan-3').text(trans[2][tnum]);
    $('.lan-4').text(trans[3][tnum]);
    $('.lan-5').text(trans[4][tnum]);
    $('.lan-6').text(trans[5][tnum]);
    $('.lan-7').text(trans[6][tnum]);
    $('.lan-8').text(trans[7][tnum]);
    $('.lan-9').text(trans[8][tnum]);
}

var trans = [{
        en: 'General',
        pt: 'Geral',
        es: 'Generalo',
        fr: 'GÃ©nÃ©rale',
        de: 'Generel',
        cn: 'ä¸€èˆ¬',
        ae: 'Ø­Ø¬Ù†Ø±Ø§Ù„ Ù„ÙˆØ§Ø¡'
    }, {
        en: 'Dashboards,widgets & layout.',
        pt: 'PainÃ©is, widgets e layout.',
        es: 'Paneloj, fenestraÄµoj kaj aranÄo.',
        fr: "Tableaux de bord, widgets et mise en page.",
        de: 'Dashboards, widgets en lay-out.',
        cn: 'ä»ªè¡¨æ¿ï¼Œå°å·¥å…·å’Œå¸ƒå±€ã€‚',
        ae: 'Ù„ÙˆØ­Ø§Øª Ø§Ù„Ù…Ø¹Ù„ÙˆÙ…Ø§Øª ÙˆØ§Ù„Ø£Ø¯ÙˆØ§Øª ÙˆØ§Ù„ØªØ®Ø·ÙŠØ·.'
    }, {
        en: 'Dashboards',
        pt: 'PainÃ©is',
        es: 'Paneloj',
        fr: 'Tableaux',
        de: 'Dashboards',
        cn: ' ä»ªè¡¨æ¿ ',
        ae: 'ÙˆØ­Ø§Øª Ø§Ù„Ù‚ÙŠØ§Ø¯Ø© '
    }, {
        en: 'Default',
        pt: 'PadrÃ£o',
        es: 'Vaikimisi',
        fr: 'DÃ©faut',
        de: 'Standaard',
        cn: 'é›»å­å•†å‹™',
        ae: 'ÙˆØ¥ÙØªØ±Ø§Ø¶ÙŠ'
    }, {
        en: 'Ecommerce',
        pt: 'ComÃ©rcio eletrÃ´nico',
        es: 'Komerco',
        fr: 'Commerce Ã©lectronique',
        de: 'E-commerce',
        cn: 'é›»å­å•†å‹™',
        ae: 'ÙˆØ§Ù„ØªØ¬Ø§Ø±Ø© Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠØ©'
    }, {
        en: 'Widgets',
        pt: 'Ferramenta',
        es: 'Vidin',
        fr: 'Widgets',
        de: 'Widgets',
        cn: 'å°éƒ¨ä»¶',
        ae: 'ÙˆØ§Ù„Ø­Ø§Ø¬ÙŠØ§Øª'
    }, {
        en: 'Page layout',
        pt: 'Layout da pÃ¡gina',
        es: 'PaÄa aranÄo',
        fr: 'Tableaux',
        de: 'Mise en page',
        cn: 'é é¢ä½ˆå±€',
        ae: 'ÙˆØªØ®Ø·ÙŠØ· Ø§Ù„ØµÙØ­Ø©'
    }, {
        en: 'Applications',
        pt: 'FormulÃ¡rios',
        es: 'Aplikoj',
        fr: 'Applications',
        de: 'Toepassingen',
        cn: 'æ‡‰ç”¨é ˜åŸŸ',
        ae: 'ÙˆØ§Ù„ØªØ·Ø¨ÙŠÙ‚Ø§Øª'
    }, {
        en: 'Ready to use Apps',
        pt: 'Pronto para usar aplicativos',
        es: 'Preta uzi Apps',
        fr: ' Applications prÃªtes Ã  lemploi ',
        de: 'Klaar om apps te gebruiken',
        cn: 'ä»ªè¡¨æ¿',
        ae: 'Ø¬Ø§Ù‡Ø² Ù„Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø§Ù„ØªØ·Ø¨ÙŠÙ‚Ø§Øª'
    },

];









/*=====================
02. Background Image js
  ==========================*/
$(".bg-center").parent().addClass('b-center');
$(".bg-img-cover").parent().addClass('bg-size');
$('.bg-img-cover').each(function () {
    var el = $(this),
        src = el.attr('src'),
        parent = el.parent();
    parent.css({
        'background-image': 'url(' + src + ')',
        'background-size': 'cover',
        'background-position': 'center',
        'display': 'block'
    });
    el.hide();
});



/*----------------------------------------
passward show hide
----------------------------------------*/
$('.show-hide').show();
$('.show-hide span').addClass('show');

$('.show-hide span').click(function () {
    if ($(this).hasClass('show')) {
        $('input[name="password"]').attr('type', 'text');
        $(this).removeClass('show');
    } else {
        $('input[name="password"]').attr('type', 'password');
        $(this).addClass('show');
    }
});
$('form button[type="submit"]').on('click', function () {
    $('.show-hide span').addClass('show');
    $('.show-hide').parent().find('input[name="password"]').attr('type', 'password');
});



//landing header //
$(".toggle-menu").click(function(){
    $('.landing-menu').toggleClass('open');
});
$(".menu-back").click(function(){
    $('.landing-menu').toggleClass('open');
});

$('.product-size ul li ').on('click', function(e) {
    $(".product-size ul li ").removeClass("active");
    $(this).addClass("active");
});

$('.email-sidebar .email-aside-toggle ').on('click', function(e) {
    $(".email-sidebar .email-left-aside ").toggleClass("open");
});

$('.job-sidebar .job-toggle ').on('click', function(e) {
    $(".job-sidebar .job-left-aside ").toggleClass("open");
});

$(".mode").on("click", function () {
    $('.mode i').toggleClass("fa-moon-o").toggleClass("fa-lightbulb-o");
    $('body').toggleClass("dark-only");
    localStorage.setItem('body', 'dark-only');// @todo save? and show?
});

// Fix CSRF token on AJAX requests
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

flatpickr.defaultConfig = {
    locale: 'nl',
    allowInput: true
}

// bootstrap-notify defaults
$.notifyDefaults({
    type: 'success',

    allow_dismiss:true,
    newest_on_top:false ,
    placement:{
        from:'bottom',
        align:'right'
    },
    offset:{
        x:30,
        y:30
    }
});

// Datatables defaults
$.extend($.fn.dataTable.defaults, {
    language: { url: "/js/datatable/i18n/nl-NL.json" }
});

$(function(){
    // Initialize flatpickr
    initFlatpicker();

    // Initialize summernote
    initSummmernote();

    // Init select2
    initSelect2();

    // Reload (all active) DataTables on changing the accountFilter select
    $('select[name="accountFilter"]').change(function(e){
        let account_id = $(this).val();
        window.sessionStorage.setItem('accountFilter', account_id);

        // Update create btn if linked
        if($(this).data('linked_create_btn')){
            if(account_id === null || account_id.length == 0) {
                $('#'+$(this).data('linked_create_btn')).attr('data-content_route', '');
                $('#'+$(this).data('linked_create_btn')).prop('disabled', true);
            }else{
                $('#'+$(this).data('linked_create_btn')).attr('data-content_route', route($(this).data('linked_create_route_name'), account_id));
                $('#'+$(this).data('linked_create_btn')).prop('disabled', false);
            }
        }

        if ($('select#businessUnitFilter').length) {
          $('select#businessUnitFilter option').show();
          if (account_id !== null && account_id.length != 0) {
            if ($('select#businessUnitFilter option:selected').data('account_id') !== account_id) {
                $('select#businessUnitFilter').val(null);
            }

            $('select#businessUnitFilter option[data-account_id!="'+account_id+'"][value!=""]').hide();
          }
        }

        $.each(window.LaravelDataTables, function(index, table){
            table.ajax.reload();
        });
    });

    // Set accountFilter on pageload, if there is a value in sessionStorage
    let accountFilterId = window.sessionStorage.getItem('accountFilter');
    if((accountFilterId === null || accountFilterId.length === 0) && $('select[name="accountFilter"] option').length === 2){
        accountFilterId = $('select[name="accountFilter"] option:nth-child(2)').val();
    }

    $('select[name="accountFilter"]').val(accountFilterId).trigger('change');

    // Reload (all active) DataTables on changing the businessUnitFilter select
    $('select[name="businessUnitFilter"]').change(function(e){
        window.sessionStorage.setItem('businessUnitFilter', $(this).val());

        $.each(window.LaravelDataTables, function(index, table){
            table.ajax.reload();
        });
    });

    // Set businessUnitFilter on pageload, if there is a value in sessionStorage
    $('select[name="businessUnitFilter"]').val(window.sessionStorage.getItem('businessUnitFilter') || '').trigger('change');


    // When setting the filter on the companies page, redirect to the companies index, with the account
    $('select[name="companiesAccountFilter"]').change(function(e){
        if($(this).val().length == 0){
            return;
        }

        window.location.href = route('account.companies', { account: $(this).val() });
    });
});

// When opening a modal, if the relatedTarget has a content_route data
// attribute, load the route into it's .modal-body
$(document).on('show.bs.modal', function(e){
    let route = $(e.relatedTarget).attr('data-content_route');
    if(typeof route === 'undefined'){
        return;
    }

    $(e.target).find('.modal-content').empty();
    addSpinner($(e.target).find('.modal-content'));
    $(e.target).find('.modal-content').load(route, function(){
        // Init datepickers in modal
        initFlatpicker();

        // Init summernote in modal
        initSummmernote();

        // Init select2 in modal
        initSelect2($(this));

        // Init feather icons in modal
        feather.replace();
    });
});

// Initialize flatpickr
window.initFlatpicker = function initFlatpicker() {
    flatpickr(".datepicker", {
      altInput: true
    });
}

window.initSummmernote = function initSummmernote() {
    $('.summernote').summernote({
        lang: 'nl-NL',
        minHeight: 75,
        tabsize: 2,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
            ['para', ['ul', 'ol']],
        ],
        callbacks: {
            onInit: function(summernote) {
                // Set height by (optional) data-height attribute on textarea
                let height = $(summernote.note[0]).data('height');
                if (typeof height !== 'undefined') {
                    $(summernote.editable[0]).css('height', height);
                }
            },
            onPaste: function (e) {
                const bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                setTimeout( function(){
                  document.execCommand( 'insertText', false, bufferText );
                }, 10 );
            }
        }
    });
}

window.initSelect2 = function initSelect2($el) {
    if(typeof $el === 'undefined'){
        $el = $(document.body);
    }

    $el.find('.select2').select2({
        dropdownParent: $el,
        minimumResultsForSearch: 5
    });
}

window.addSpinner = function addSpinner($el) {
    $el.append(`<div class="modal-loader-wrapper my-4">
                    <div class="theme-loader">
                        <div class="loader-p"></div>
                    </div>
                </div>`);
}

// Process the input phonenumber and set an E164 format
// Assumes there is an intlTelInput variable named phoneInput
window.process_phonenumber = function process_phonenumber(event){
    const phoneNumber = phoneInput.getNumber();
    phoneInputField.value = phoneNumber;
}

// Employee Dossier
$(document).on('submit', '#edit_employee_dossier', function(e){
    e.preventDefault();
    e.stopPropagation();

    let formData = new FormData($(this)[0]);

    let tableId = 'employee_dossier_table';
    if(formData.get('parentable_type') === 'App\\Models\\EmployeeSickLeave'){
        tableId = 'sick_leaves_dossier_table'+formData.get('parentable_id');
    }

    $.ajax({
        type: 'POST',
        url: $(this).attr('action'),
        data: formData,
        async: false,
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function(data){
            // Hide validation errors
            $('#edit_dossier_modal_errors').addClass('d-none');

            // Close modal(s)
            $('#edit_dossier_modal').modal('hide');
            $('#show_alert_modal').modal('hide');

            // Show feedback
            $.notify({
                message: 'Dossier item opgeslagen'
            });

            // Reload datatable(s)
            if(typeof window.LaravelDataTables[tableId] !== 'undefined'){
                window.LaravelDataTables[tableId].ajax.reload(null, false);
            }
            if(typeof window.LaravelDataTables['alerts_table'] !== 'undefined'){
                window.LaravelDataTables['alerts_table'].ajax.reload(null, false);
            }
        },
        error: function(jqXHR){
            // Show validation errors
            $('#edit_dossier_modal_errors ul li').remove();

            $.each(jqXHR.responseJSON.errors, function(key, errors){
                $.each(errors, function(key, error){
                    $('#edit_dossier_modal_errors ul').append('<li>'+error+'</li>');
                });
            });

            $('#edit_dossier_modal_errors').removeClass('d-none');
        }
    });
});

$(document).on('click', '.employee_dossier_destroy', function(e){
    e.preventDefault();
    e.stopPropagation();

    $table = $(e.currentTarget).parents('table');
    let tableId = $table.attr('id');

    // Ask for confirmation before destroying
    Swal.fire({
        title: 'Weet u zeker dat u dit dossier item wilt verwijderen?',// @todo @lang
        text: "Dit kan niet ongedaan worden!",// @todo @lang
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Annuleren',// @todo @lang
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Verwijderen'// @todo @lang
    }).then((result) => {
        if (result.isConfirmed) {
            // Send ajax request for destroying the object
            $.ajax({
                type: 'POST',
                url: $(this).data('route'),
                data: {
                    "_method": "DELETE",
                    "_token": $(this).parents('form').find('input[name="_token"]').val()
                },
                dataType: 'json',
                success: function(data){
                    // Show feedback
                    $.notify({
                        message: 'Dossier item verwijderd'// @todo @lang
                    });

                    // Reload datatable
                    window.LaravelDataTables[tableId].ajax.reload(null, false);
                },
                error: function(jqXHR){
                    // Show feedback
                    $.notify({
                        message: 'Er is iets misgegaan met het verwijderen van het dossier item. Probeer het nogmaals.'// @todo @lang
                    }, {
                        type: 'danger'
                    });
                }
            });
        }
    });
});

openTab = function(tabId) {
    let $tab = $('#'+tabId);

    if ($tab.parents('.tab-pane').length > 0) {
        var parentTabTriggerEl = document.querySelector('#' + $tab.parents('.tab-pane').attr('aria-labelledby'));
        var parentTab = new bootstrap.Tab(parentTabTriggerEl);
        parentTab.show();
    }

    var tabTriggerEl = document.querySelector('#' + $tab.attr('aria-labelledby'));
    var tab = new bootstrap.Tab(tabTriggerEl);
    tab.show();
}
